import './dropdown.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import onClickOutside from 'react-onclickoutside';

const propTypes = {
	children: PropTypes.element,
	placeholder: PropTypes.array
};

class Dropdown extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};
	}

	render() {
		return (
			<div className={cn('switch-control-dropdown', this.state.isOpen && 'switch-control-dropdown--opened')}>
				<div className="switch-control-dropdown__head" onClick={ this.onToggle.bind(this) }>
					<span className="title__value">{this.props.placeholder[0]}</span>
					{ this.props.placeholder.length > 1 && (
						<span className="title__count" />
					) }
				</div>

				{ this.state.isOpen && (
					<div className="switch-control-dropdown__suggest">
						{ this.props.children }
					</div>
				) }
			</div>
		);
	}

	handleClickOutside() {
		if (this.state.isOpen) {
			this.onToggle();
		}
	}

	onToggle() {
		this.setState({
			isOpen: !this.state.isOpen
		});
	}
}

Dropdown.propTypes = propTypes;

export default onClickOutside(Dropdown);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/switch-control/hoc/decorator/dropdown.js